import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

/*
    Category Over Time doesn't have any custom settings set from the settings modal; instead
    this class is used to hide the agent selector and force the team (group) selector to expand
*/

@Component({
    selector: 'cv-category-over-time-settings',
    templateUrl: './category-over-time-settings.component.html',
    styleUrls: ['./category-over-time-settings.component.scss']
})
export class CategoryOverTimeSettingsComponent implements OnInit, OnDestroy {
    @Input() moduleManager: ModuleManager;

    //subscriptions used 
    private onSettingsSub;
    private onCancelledSub;
    private onAppliedSub;

    constructor() { }

    ngOnInit(): void {
        //subscribe to cancel/save events to remove css that hides agent selection
        this.onSettingsSub = this.moduleManager.slideoutSettingsManager.subscribe((value) => this.settingsMangerHandler(value));
    }

    ngOnDestroy(): void {
        this.unhideAgentSelection();
        this.onSettingsSub.unsubscribe();
    }

    settingsMangerHandler(value) {
        if (value == null)
            return;

        this.hideAgentSelection();
        this.onCancelledSub = value.onSettingsCancelled.subscribe((value2) => this.unhideAgentSelection(value));
        this.onAppliedSub = value.onSettingsApplied.subscribe((value2) => this.unhideAgentSelection(value));
    }

    hideAgentSelection() {
        let style = document.createElement('style');
        const head = document.head || document.getElementsByTagName('head')[0];
        style.id = "HideAgentSelection";
        style.type = 'text/css';
        style.appendChild(document.createTextNode('.group-selector-container > div:nth-child(2).col{display: none !important;}'));
        head.appendChild(style);
    }

    unhideAgentSelection(value = null) {
        let style = document.getElementById("HideAgentSelection");
        if (!!style)
            document.head.removeChild(style);

        if (value != null) {
            this.onCancelledSub.unsubscribe();
            this.onAppliedSub.unsubscribe();
        }
    }
}
